import { render } from "./ChannelBan.vue?vue&type=template&id=98dd764e"
import script from "./ChannelBan.vue?vue&type=script&lang=ts"
export * from "./ChannelBan.vue?vue&type=script&lang=ts"
script.render = render

export default script